import { render, staticRenderFns } from "./HomeContentsList.vue?vue&type=template&id=2d58d5c2&scoped=true&"
import script from "./HomeContentsList.vue?vue&type=script&lang=js&"
export * from "./HomeContentsList.vue?vue&type=script&lang=js&"
import style0 from "./HomeContentsList.vue?vue&type=style&index=0&id=2d58d5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58d5c2",
  null
  
)

export default component.exports